import React from 'react'
import './style.css'

import {useSelector,useDispatch} from 'react-redux'
export default function Backdrop(props) {
    const general=useSelector(state=>state.general)
    const {modal_action,modal_type}=general
    // console.log('modal_action', modal_action)
    return (
        <div>
            <div className='backdrop-wrapper' onClick={modal_action!=='upload_file'&&props.modalToggleReset}>
                
            </div>
        </div>
        
    )
}
